import styled from "styled-components";
import { FlexMixin, FontMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
export const Wrapper = styled.div.withConfig({
    displayName: "styled__Wrapper",
    componentId: "sc-fecb429a-0"
})`
	${FontMixin({
    size: 'medium',
    weight: 'light',
    height: 'base'
})}
	color: ${({ theme  })=>theme.colors.grays.darker};
	b {
		${FontMixin({
    weight: 'medium'
})}
		text-transform: uppercase;
	}
	margin-bottom: 10px;
`;
export const Label = styled.span.withConfig({
    displayName: "styled__Label",
    componentId: "sc-fecb429a-1"
})`
	font-weight: 500;
	text-transform: uppercase;
	margin-right: 4px;
`;
export const DateLabel = styled.span.withConfig({
    displayName: "styled__DateLabel",
    componentId: "sc-fecb429a-2"
})`
	${FontMixin({
    weight: 'regular'
})}
`;
export const Airport = styled.div.withConfig({
    displayName: "styled__Airport",
    componentId: "sc-fecb429a-3"
})`
	${FontMixin({
    size: 'small'
})}
	color: ${({ theme  })=>theme.colors.grays.dark};
`;
export const Row = styled.div.withConfig({
    displayName: "styled__Row",
    componentId: "sc-fecb429a-4"
})`
	${FlexMixin({
    justify: 'flex-start',
    align: 'center',
    wrap: true
})}
	white-space: pre;

	img {
		margin-left: 4px;
	}
`;
export const Company = styled.span.withConfig({
    displayName: "styled__Company",
    componentId: "sc-fecb429a-5"
})`
	color: ${({ theme  })=>theme.colors.primary.lighter};
`;

//# sourceMappingURL=styled.js.map